import api from './api.js';

export const storeAPI = {
    list: () => api.get('/api/admin/stores'),
    listArchived: () => api.get('/api/admin/stores/archived'),
    create: (payload) => api.post('/api/admin/stores', payload),
    select: (id) => api.post(`/api/admin/stores/${id}/select`),
    restore: (id) => api.post(`/api/admin/stores/${id}/restore`),
    rename: (id, payload) => api.patch(`/api/admin/stores/${id}`, payload),
    delete: (id, payload) => api.delete(`/api/admin/stores/${id}`, { data: payload }),
    purgeForever: (id, payload) =>
        api.delete(`/api/admin/stores/${id}/forever`, { data: payload }),
    listCatalogThemes: (storeType) =>
        api.get('/api/admin/stores/themes/catalog', { params: { storeType } }),
    getStoreThemes: (storeId) => api.get(`/api/admin/stores/${storeId}/themes`),
    addStoreTheme: (storeId, themeId) =>
        api.post(`/api/admin/stores/${storeId}/themes/${themeId}/add`),
    updateStoreTheme: (storeId, payload) =>
        api.patch(`/api/admin/stores/${storeId}/themes`, payload),
    activateStoreTheme: (storeId, themeId) =>
        api.post(`/api/admin/stores/${storeId}/themes/${themeId}/activate`),
    removeStoreTheme: (storeId, themeId) =>
        api.delete(`/api/admin/stores/${storeId}/themes/${themeId}`),
    listCustomDomains: (storeId) => api.get(`/api/admin/stores/${storeId}/custom-domains`),
    addCustomDomain: (storeId, payload) =>
        api.post(`/api/admin/stores/${storeId}/custom-domains`, payload),
    verifyCustomDomain: (storeId, domainId) =>
        api.post(`/api/admin/stores/${storeId}/custom-domains/${domainId}/verify`),
    setPrimaryCustomDomain: (storeId, domainId) =>
        api.patch(`/api/admin/stores/${storeId}/custom-domains/${domainId}/primary`),
    removeCustomDomain: (storeId, domainId) =>
        api.delete(`/api/admin/stores/${storeId}/custom-domains/${domainId}`),
};
